
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("gnN3I", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $bed4d96cfe51b496$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $fppBw = parcelRequire("fppBw");

var $gxXVf = parcelRequire("gxXVf");

var $k77lQ = parcelRequire("k77lQ");

var $69aHU = parcelRequire("69aHU");

var $7bL1M = parcelRequire("7bL1M");

var $bgcaM = parcelRequire("bgcaM");

var $kXs6I = parcelRequire("kXs6I");

var $hnwsY = parcelRequire("hnwsY");
const $bed4d96cfe51b496$var$extensionUtils = {
    openMacroBrowserForInitialConfiguration: $gxXVf.openMacroBrowserForInitialConfiguration,
    openMacroBrowserToEditExistingMacro: $gxXVf.openMacroBrowserToEditExistingMacro,
    loadMacroBrowserResources: $7bL1M.loadMacroBrowserResources,
    getMigrationExtensionManifest: $bgcaM.getMigrationExtensionManifest,
    getExtensionHandlers: $k77lQ.getExtensionHandlers,
    populateExtensionProviders: $69aHU.populateExtensionProviders,
    Changeboarding: $hnwsY.default
};
/**
 * A component to inject extension v1 related functions into the editor extension context.
 * WARN: this component must not be used directly but only via Loadable.
 */ const $bed4d96cfe51b496$var$ClassicEditorContextProvider = ({ children: children, isWithinEditor: isWithinEditor = false })=>{
    const ClassicEditorContextValue = (0, $gwFzn.useMemo)(()=>({
            ...$bed4d96cfe51b496$var$extensionUtils,
            isWithinEditor: isWithinEditor
        }), [
        isWithinEditor
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kXs6I.ClassicEditorContext).Provider, {
        value: ClassicEditorContextValue
    }, children);
};
$bed4d96cfe51b496$var$ClassicEditorContextProvider.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).node.isRequired,
    isWithinEditor: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool
};
var $bed4d96cfe51b496$export$2e2bcd8739ae039 = $bed4d96cfe51b496$var$ClassicEditorContextProvider;

});
parcelRegister("hnwsY", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca6dc4c2a3145595$export$2e2bcd8739ae039);

var $fppBw = parcelRequire("fppBw");

var $cKyDI = parcelRequire("cKyDI");

var $ggM8l = parcelRequire("ggM8l");

var $7LBmH = parcelRequire("7LBmH");

var $ieAat = parcelRequire("ieAat");

var $gs8vo = parcelRequire("gs8vo");
const $ca6dc4c2a3145595$var$mapStateToProps = (state, ownProps)=>({
        discoveredFeaturesLoaded: (0, $ggM8l.haveDiscoveredFeaturesBeenLoaded)(state),
        shouldRender: (0, $ieAat.shouldChangeboardingInstanceRender)(state, ownProps) && !(0, $ieAat.isChangeboardingUrlBlacklisted)(state),
        spotlightHasBeenInvoked: (0, $ieAat.hasSpotlightBeenInvoked)(state.views.changeboarding, ownProps)
    });
const $ca6dc4c2a3145595$var$mapDispatchToProps = (dispatch)=>({
        showChangeboardingSpotlight ({ delaySpotlight: delaySpotlight = 0, spotlightId: spotlightId, changeboardFlowFinished: changeboardFlowFinished, spotlightAttributes: spotlightAttributes }) {
            setTimeout(()=>{
                dispatch((0, $7LBmH.showChangeboardingSpotlight)({
                    spotlightId: spotlightId,
                    changeboardFlowFinished: changeboardFlowFinished,
                    spotlightAttributes: spotlightAttributes
                }));
            }, delaySpotlight);
        }
    });
const $ca6dc4c2a3145595$var$Changeboarding = (0, $cKyDI.connect)($ca6dc4c2a3145595$var$mapStateToProps, $ca6dc4c2a3145595$var$mapDispatchToProps)((0, $gs8vo.default));
$ca6dc4c2a3145595$var$Changeboarding.propTypes = {
    spotlightId: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
    startDate: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).instanceOf(Date),
    endDate: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).instanceOf(Date),
    darkFeatureEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
    darkFeatureDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
    delaySpotlight: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).number,
    spotlightAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).shape({
        heading: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).element
        ]).isRequired,
        footer: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).element
        ]).isRequired,
        targetBgColor: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
        targetRadius: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).number,
        dialogPlacement: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).oneOf([
            'top left',
            'top center',
            'top right',
            'right top',
            'right middle',
            'right bottom',
            'bottom left',
            'bottom center',
            'bottom right',
            'left top',
            'left middle',
            'left bottom'
        ]),
        dialogWidth: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).number
    })
};
$ca6dc4c2a3145595$var$Changeboarding.displayName = 'Changeboarding';
var $ca6dc4c2a3145595$export$2e2bcd8739ae039 = $ca6dc4c2a3145595$var$Changeboarding;

});
parcelRegister("gs8vo", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfa5dbdbe6f0e00d$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $fppBw = parcelRequire("fppBw");

var $6pc4Q = parcelRequire("6pc4Q");

var $9FYW3 = parcelRequire("9FYW3");
class $bfa5dbdbe6f0e00d$export$2e2bcd8739ae039 extends (0, $gwFzn.Component) {
    componentDidMount() {
        (0, $9FYW3.SPOTLIGHT_CALLBACKS)[this.props.spotlightId] = this.props.changeboardFlowFinished;
    }
    render() {
        const { children: children, shouldRender: shouldRender, spotlightId: spotlightId, delaySpotlight: delaySpotlight, spotlightHasBeenInvoked: spotlightHasBeenInvoked, showChangeboardingSpotlight: showChangeboardingSpotlight, spotlightAttributes: spotlightAttributes } = this.props;
        if (!shouldRender) return children;
        if (!spotlightHasBeenInvoked) showChangeboardingSpotlight({
            spotlightId: spotlightId,
            delaySpotlight: delaySpotlight,
            spotlightAttributes: spotlightAttributes
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6pc4Q.ChangeboardingTargetLazyLoader), {
            spotlightId: spotlightId,
            delaySpotlight: delaySpotlight,
            spotlightAttributes: spotlightAttributes
        }, children);
    }
}
$bfa5dbdbe6f0e00d$export$2e2bcd8739ae039.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).any,
    shouldRender: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool.isRequired,
    spotlightId: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string.isRequired,
    showChangeboardingSpotlight: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func.isRequired,
    discoveredFeaturesLoaded: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool.isRequired,
    spotlightHasBeenInvoked: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool.isRequired,
    delaySpotlight: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).number,
    spotlightAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).object,
    changeboardFlowFinished: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func
};

});




//# sourceMappingURL=ClassicEditorContextProvider.4922fa3b.js.map
